var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerElectricityConsumerUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710-370v-60h120v60H710Zm0 160v-60h120v60H710Zm-220 40v-80h-80v-140h80v-80h180v300H490ZM130-290v-300h280v-140H170v-60h300v260H190v180h180v60H130Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerElectricityConsumerUnitIcon);
export default __webpack_public_path__ + "static/media/marker-electricityConsumerUnit-icon.a563b1b0e900db5d2e4e10d9bde61edb.svg";
export { ForwardRef as ReactComponent };